module.exports = __webpack_public_path__ + "img/food_default_cover.6279f392.png";